// humanizeEventName — display-prettify a CamelCase SAP CPQ event name
// ("AfterAddingProductsToQuote" -> "After adding products to quote") for the
// v2 Execution order view. Deliberately a generic splitter, NOT a hand label
// map: the server-side event map (knowledge/event_context_map.py) grows, and
// a JS copy would drift.
//
// Untouched (returned verbatim): names with underscores or spaces (server
// fallbacks like "Event_123"), ALL-CAPS names (tenant-defined), and anything
// with characters outside [A-Za-z0-9]. Embedded acronyms (>1 consecutive
// capitals) keep their casing.
//
// Own module (not pipeline.js): pipeline.js touches `window` at module scope,
// so a plain-node unit test can import THIS file but not that one.
export function humanizeEventName(name) {
  if (typeof name !== "string" || !name) return name;
  if (!/^[A-Za-z0-9]+$/.test(name)) return name;      // underscores, spaces, punctuation
  if (name === name.toUpperCase()) return name;        // ALL-CAPS tenant names
  if (!/[a-z]/.test(name) || !/[A-Z]/.test(name)) return name; // nothing to split
  const words = name
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
    .split(" ");
  return words
    .map((w, i) => {
      if (w.length > 1 && w === w.toUpperCase()) return w; // acronym (POD, VAS…)
      if (i === 0) return w[0].toUpperCase() + w.slice(1).toLowerCase();
      return w.toLowerCase();
    })
    .join(" ");
}
